import { useCallback, useState } from "react";

export const useElementHeight = () => {
  const [height, setHeight] = useState<number | undefined>(undefined);

  const ref = useCallback((node?: HTMLElement | null) => {
    if (!node) {
      return;
    }
    setHeight(node.clientHeight);
  }, []);

  return {
    ref,
    height,
  };
};
